import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext, ALERT_TYPES, ERROR_SEVERITY } from 'commons-ui';
import lodash from 'lodash';
import useService from './useService';
import { Record } from './helper';

const useCampaignDetails = () => {
	const [showLoader, setShowLoader] = useState(false);
	const [csvFile, setCSVFile] = useState<File | null>(null);
	const [campaignName, setCampaignName] = useState<string>('');
	const [csvCampaignName, setCsvCampaignName] = useState<string>('');
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const { addCampaignData, uploadCampaignDataCsv } = useService();

	const handleFormSubmit = async (submittedData: Record) => {
		setShowLoader(true);
		const { athenaQueryText, campaignName: submittedCampaignName } = submittedData;
		setCampaignName(submittedCampaignName as string);
		try {
			if (!lodash.isString(athenaQueryText) || lodash.isEmpty(athenaQueryText.trim())) {
				showAlert('Invalid athena query text!!', { type: ERROR_SEVERITY.ERROR });
				setShowLoader(false);
			} else if (!lodash.isString(submittedCampaignName) || lodash.isEmpty(submittedCampaignName.trim())) {
				showAlert('Invalid campaign name!!', { type: ERROR_SEVERITY.ERROR });
				setShowLoader(false);
			} else {
				const isRespSuccess: boolean = await addCampaignData(athenaQueryText, submittedCampaignName, showAlert);
				if (isRespSuccess) {
					showAlert('Athena Query submitted successfully', { type: ALERT_TYPES.SUCCESS });
				}
				setShowLoader(false);
			}
		} catch (error: any) {
			showAlert(error.error || 'Something went wrong', { type: ERROR_SEVERITY.ERROR });
			setShowLoader(false);
		}
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	const handleFileUpload = async (uploadedFiles: File[]) => {
		if (uploadedFiles.length > 1) {
			showAlert('Please upload only one CSV file', { type: 'error' });
			return;
		}

		const file = lodash.first(uploadedFiles);
		if (!file) return;

		if (!file.name.toLowerCase().endsWith('.csv')) {
			showAlert('Please upload a CSV file', { type: 'error' });
			return;
		}

		setCSVFile(file);
	};

	const uploadCsvFile = async () => {
		if (!csvFile) return;

		if (!csvCampaignName.trim()) {
			showAlert('Please enter Campaign Name before uploading CSV', { type: 'error' });
			return;
		}

		setShowLoader(true);
		try {
			const isSuccess = await uploadCampaignDataCsv(csvFile, csvCampaignName, showAlert);
			if (isSuccess) {
				setCSVFile(null);
				setCsvCampaignName('');
			}
		} finally {
			setShowLoader(false);
		}
	};

	return {
		showLoader,
		setShowLoader,
		handleFormSubmit,
		handleFormCancel,
		handleFileUpload,
		csvFile,
		uploadCsvFile,
		showAlert,
		campaignName,
		csvCampaignName,
		setCsvCampaignName
	};
};

export default useCampaignDetails;
